module.exports = __webpack_public_path__ + "static/media/låse.78548d7f.m4a";